import React, { useState } from 'react';
import axios from 'axios'; // Ensure axios is installed: npm install axios

const PurchaseCardModal = ({ show, onClose }) => {
  // const [step, setStep] = useState(1); // 1: Shipping, 2: Payment
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ name: '', phone: '' });
  const [errors, setErrors] = useState({});

  if (!show) return null;

  // --- HANDLERS ---
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: '' });
  };

  const validateStep1 = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.phone || !/^03\d{9}$/.test(formData.phone)) newErrors.phone = "Invalid Phone (03xxxxxxxxx)";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // --- STRIPE CHECKOUT HANDLER (Fixed & Robust) ---
  const handleStripeCheckout = async () => {
    setLoading(true);

    // 1. ROBUST ID CHECK: Look in all possible storage keys
    let userId = localStorage.getItem("userId");

    // If not found, check "user" object (standard MERN auth)
    if (!userId && localStorage.getItem("user")) {
      try {
        const u = JSON.parse(localStorage.getItem("user"));
        userId = u._id || u.id;
      } catch (e) { console.error("Error parsing user from local storage"); }
    }

    // If still not found, check "DDoctorUser" (Your specific app key)
    if (!userId && localStorage.getItem("DDoctorUser")) {
      try {
        const u = JSON.parse(localStorage.getItem("DDoctorUser"));
        userId = u._id || u.id;
      } catch (e) { console.error("Error parsing DDoctorUser"); }
    }

    // DEBUG: Print what we found to the console
    console.log("Stripe Checkout - Found User ID:", userId);

    if (!userId) {
      alert("System Error: Could not find your User ID. Please log out and log in again.");
      setLoading(false);
      return;
    }

    try {
      // 2. Request the Checkout URL from your Backend using AXIOS
      // Note: We send 'address' (Backend expects this) using 'formData.street'
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/cards/create-checkout-session`, {
        userId: userId,
        name: formData.name,       // Backend uses this for "holderName"
        phone: formData.phone,

      });

      // 3. REDIRECT TO STRIPE
      if (response.data.url) {
        window.location.href = response.data.url;
      } else {
        alert("Server Error: No payment URL returned.");
      }

    } catch (error) {
      console.error("Checkout Network Error:", error);
      const serverMsg = error.response?.data?.error || error.message;
      alert("Payment Failed: " + serverMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" style={styles.overlay}>
      <div className="modal-content" style={styles.modal}>

        {/* Header */}
        <div className="d-flex justify-content-between mb-4"style={{ padding: '30px' }}>
          <h5 className="fw-bold" style={{ color: '#0070E0' }}>Get Virtual Gold Card</h5>
          <button onClick={onClose} style={styles.closeBtn}>&times;</button>
        </div>

        {/* Body Content */}
        <div className="mb-3 p-4">
          <p className="text-muted small">
            Enter your details to generate your NFT Membership.
          </p>

          {/* Name Input */}
          <div className="mb-3 ">
            <label className="form-label small fw-bold">Full Name</label>
            <input
              type="text" name="name"
              className={`form-control ${errors.name ? 'is-invalid' : ''}`}
              placeholder="Ali Khan"
              value={formData.name} onChange={handleChange}
            />
            {errors.name && <div className="invalid-feedback">{errors.name}</div>}
          </div>

          {/* Phone Input */}
          <div className="mb-3">
            <label className="form-label small fw-bold">Phone Number</label>
            <input
              type="tel" name="phone" maxLength="11"
              className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
              placeholder="0300 1234567"
              value={formData.phone} onChange={handleChange}
            />
            {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
          </div>

          {/* Price Summary */}
          <div className="bg-light p-3 rounded mb-3 border d-flex justify-content-between align-items-center">
            <span className="text-secondary fw-bold small">Total Price</span>
            <span className="fw-bold text-dark">PKR 5,000</span>
          </div>

          <div className="alert alert-info py-2 small">
            <i className="bi bi-info-circle me-2"></i>
            This is a <strong>Digital Only</strong> membership.
          </div>
        </div>

        {/* Footer Button */}
        <button
          className="btn btn-primary w-100 py-3 fw-bold"
          onClick={handleStripeCheckout}
          disabled={loading}
          style={{ backgroundColor: '#00004d', border: 'none' }}
        >
          {loading ? 'Processing...' : 'Pay with Stripe'}
        </button>

      </div>
    </div>
  );

  // return (
  //   <div className="modal-overlay" style={styles.overlay}>
  //     <div className="modal-content" style={styles.modal}>

  //       {/* === STEP 1: SHIPPING DETAILS === */}
  //       {step === 1 ? (
  //         <div style={{ padding: '30px' }}> 
  //           <div className="d-flex justify-content-between mb-4">
  //             <h5 className="fw-bold">Shipping Details</h5>
  //             <button onClick={onClose} style={styles.closeBtn}>&times;</button>
  //           </div>

  //           <div className="mb-3">
  //             <label className="form-label text-muted small">Full Name</label>
  //             <input 
  //               type="text" name="name" 
  //               value={formData.name}
  //               className={`form-control ${errors.name ? 'is-invalid' : ''}`} 
  //               onChange={handleChange} 
  //             />
  //           </div>
  //           <div className="mb-3">
  //             <label className="form-label text-muted small">Phone (03xxxxxxxxx)</label>
  //             <input 
  //               type="tel" name="phone" maxLength="11" 
  //               value={formData.phone}
  //               className={`form-control ${errors.phone ? 'is-invalid' : ''}`} 
  //               onChange={handleChange} 
  //             />
  //           </div>
  //           {/* <div className="mb-3">
  //             <label className="form-label text-muted small">Address</label>
  //             <input 
  //               type="text" name="street" 
  //               value={formData.street}
  //               className={`form-control ${errors.street ? 'is-invalid' : ''}`} 
  //               onChange={handleChange} 
  //             />
  //           </div> */}
  //           {/* <div className="d-flex gap-2 mb-3">
  //             <input 
  //               type="text" name="city" placeholder="City" 
  //               value={formData.city}
  //               className={`form-control ${errors.city ? 'is-invalid' : ''}`} 
  //               onChange={handleChange} 
  //             />
  //             <input 
  //               type="text" name="postalCode" placeholder="Zip Code" 
  //               value={formData.postalCode}
  //               className="form-control" 
  //               onChange={handleChange} 
  //             />
  //           </div> */}

  //           <button className="btn btn-primary w-100" onClick={() => { if (validateStep1()) setStep(2); }}>
  //             Continue to Payment
  //           </button>
  //         </div>
  //       ) : (

  //         /* === STEP 2: ORDER SUMMARY & PAY === */
  //         <div style={{ padding: '30px' }}>
  //           <div className="d-flex align-items-center mb-4">
  //             <button onClick={() => setStep(1)} style={styles.backBtn}><i className="bi bi-arrow-left"></i></button>
  //             <h5 className="fw-bold mb-0 ms-2">Order Summary</h5>
  //           </div>

  //           {/* --- PRODUCT DETAILS (UI ONLY) --- */}
  //           <div className="bg-light p-3 rounded mb-4 border">
  //             <div className="d-flex justify-content-between align-items-center mb-2">
  //               <div>
  //                 <h6 className="fw-bold mb-0 text-primary">DDoctor Gold Membership</h6>
  //                 <small className="text-muted">1 Year Validity • 50% Off</small>
  //               </div>
  //               <span className="badge bg-warning text-dark">Gold</span>
  //             </div>
  //             <hr className="my-2" />
  //             <div className="d-flex justify-content-between align-items-center">
  //               <span className="text-secondary fw-bold">Total</span>
  //               <span className="fs-5 fw-bold">PKR 5,000.00</span>
  //             </div>
  //           </div>

  //           <div className="alert alert-info py-2 small">
  //             <i className="bi bi-shield-lock me-2"></i>
  //             You will be redirected to Stripe to complete your secure payment.
  //           </div>

  //           {/* --- STRIPE BUTTON --- */}
  //           <button
  //             className="btn btn-primary w-100 py-3 fw-bold shadow-sm"
  //             onClick={handleStripeCheckout}
  //             disabled={loading}
  //             style={{ backgroundColor: '#635bff', borderColor: '#635bff' }} // Stripe's Brand Color
  //           >
  //             {loading ? 'Redirecting...' : 'Pay with Stripe'}
  //           </button>
  //         </div>
  //       )}
  //     </div>
  //   </div>
  // );
};

// --- STYLES ---
const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050,
    display: 'flex', justifyContent: 'center', alignItems: 'center'
  },
  modal: {
    backgroundColor: '#fff', borderRadius: '8px', width: '95%', maxWidth: '450px',
    boxShadow: '0 8px 30px rgba(0,0,0,0.12)', overflow: 'hidden'
  },
  closeBtn: { background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' },
  backBtn: { background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', padding: 0 }
};

export default PurchaseCardModal;